




import Vue from "vue";
import NotificationDataUpload from "@/components/notification-data/notification-data-download.component.vue";
export default Vue.extend({
  components: {
    "notification-data-download": NotificationDataUpload,
  },
});
